import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import VehicleForm from "../Components/VehicleForm.js"
import CirclePlus from '../images/dbplus@3x.png'
import Modal from 'react-modal';
import AppointmentService from '../utils/AppointmentService.js';
import Sedan from '../images/spiffysedan.svg'
import NonSedan from '../images/nonsedan.svg'
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class Vehicle extends Component {
  constructor(props) {
    super(props)

    this.ApptService = new AppointmentService()
    if(this.props.vehicles && this.props.vehicles.vehicles && this.props.vehicles.vehicles.length < 1){
      this.state = {
        modalIsOpen: true,
        vehicles:this.props.vehicles,
        selectedVehicle: null,
        width: document.body.clientWidth
      };
    }
    else {
      this.state = {
        modalIsOpen: false,
        vehicles:this.props.vehicles,
        selectedVehicle: null,
        width: document.body.clientWidth
      };
    }
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.selectVehicle = this.selectVehicle.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillReceiveProps(nextProps) {

      this.setState({
        vehicles: nextProps.vehicles,
      });
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  openModal() {
    this.setState({modalIsOpen: true});
  }
  closeModal() {
    this.setState({modalIsOpen: false});
    this.ApptService.vehicles()
    .then(res =>{
      if(res){
        const vehicles = res
        this.setState({vehicles: vehicles});
        this.forceUpdate()
      }
      else {
        throw new Error('Response for fetching vehicles is not valid: ' + res);
      }
      //  this.props.history.replace('/');
    })
    .catch(err =>{
        this.props.setError("Error retrieving vehicles")
        throw new Error('Error retrieving vehicles: ' + err.message);
    })
  }
  selectVehicle = (vehicle) => {
     if (typeof this.props.selectVehicle === 'function') {
       this.props.selectVehicle(vehicle)
     }
  }

  render() {
    if(this.state.vehicles.vehicles){
      var vehiclesHTML = []
      var this_2 = this
      this.state.vehicles.vehicles.forEach(function(vehicle) {
        var bg_color = this_2.props && this_2.props.selectedVehicle && this_2.props.selectedVehicle.id === vehicle.id ? "#ff8c00" : "white";
        if(vehicle.vehicle_type.vtype == 'SEDAN'){
          vehiclesHTML.push(<li key={"vehicle" + vehicle.id} id={"vehicle" + vehicle.id} style={{backgroundColor:bg_color}} className="list-group-item"  data-vehicleid={vehicle.id} onClick={() => this_2.selectVehicle(vehicle)}><img className="float-left mr-3 list-icon" src={Sedan}></img>{vehicle.make}<br></br>{vehicle.model}</li>)
        }
        else {
          vehiclesHTML.push(<li key={"vehicle" + vehicle.id} id={"vehicle" + vehicle.id} style={{backgroundColor:bg_color}} className="list-group-item" data-vehicleid={vehicle.id} onClick={() => this_2.selectVehicle(vehicle)}><img className="float-left mr-3 list-icon" src={NonSedan}></img>{vehicle.make}<br></br>{vehicle.model}</li>)
        }
        });
      }
      const modalStyle =
      this.state.width < 780 ?
      {
        content: {
          top                   : '22.5%',
          left                  : '0%',
          height                : '55%',
          width                 : '100%',
          padding               : '0px',
          right                 : 'auto',
          color                 : 'white',
        }
      }:
        {
          content: {
            top                   : '22.5%',
            left                  : '30%',
            height                : '55%',
            width                 : '40%',
            padding               : '0px',
            right                 : 'auto',
            color                 : 'white',
          }
        }
    return (
          <div className="card float">
            <div className="card-header text-white text-center ">
              <h4>Select Vehicle<button className="btn btn-primary btn-sm float-right addIconButton"><img src={CirclePlus} onClick={this.openModal}></img></button></h4>
            </div>
            <ul className="list-group list-group-flush align-content-center">
              {vehiclesHTML}
            </ul>
            <Modal
              style={modalStyle}
              isOpen={this.state.modalIsOpen}
              contentLabel="Example Modal">
              <div className="card-header blue-background text-white text-center dateTimeContainer ">
                Add Vehicle
              </div>
              <VehicleForm selectVehicle = {this.selectVehicle} closeModal={this.closeModal}/>

            </Modal>
          </div>
    )
  }
}
export default Vehicle



// WEBPACK FOOTER //
// ./src/Components/Vehicle.js